<template>
  <v-container style="overflow: hidden">
    <span class="ct-text-subtitle2 bold fourth--text"
      >(本平臺統計範圍為全國公立高級中等以下學校)</span
    >
    <v-row class="d-flex justify-space-between align-center">
      <v-col>
        <MapTitle title="統計成果">
          <!-- <div
            v-if="sideStaticContent.hasInfoCard"
            role="button"
            tabindex="0"
            class="btnTreeQR"
          ></div> -->
        </MapTitle>
      </v-col>
    </v-row>
    <v-row class="d-flex flex-lg-nowrap justify-center align-center">
      <v-col
        class="d-flex flex-sm-nowrap flex-wrap justify-center align-center px-0"
      >
        <v-col class="d-flex justify-center align-center">
          <StaticChip
            title="喬木樹種"
            :value="sideStaticContent.treeDistinctList.length"
          />
        </v-col>

        <v-col class="d-flex justify-center align-center">
          <StaticChip title="調查數量" :value="sideStaticContent.treeCount" />
        </v-col>
      </v-col>
      <!-- 20250625 carbon hidden -->
      <!-- <v-col
        class="d-flex  flex-sm-nowrap flex-wrap justify-center align-center px-0"
      >
        <v-col class="d-flex justify-center align-center">
          <StaticChip
            color="third"
            :title="
              `總固碳量估算${
                sideStaticContent.searchPara.school ? '(kg CO2e)' : '(ton CO2e)'
              }`
            "
            :width="null"
            :value="
              sideStaticContent.searchPara.school
                ? Math.round(tonCO2e * 10 * 1000) / 10
                : Math.round(tonCO2e * 10) / 10
            "
          />
        </v-col>
        <v-col class="d-flex justify-center align-center">
          <StaticChip color="third" title="相當用電度數" :value="kWh" />
        </v-col>
      </v-col> -->
    </v-row>
    <!-- 20250625 carbon hidden -->
    <!-- <v-row class="d-flex justify-space-between align-center">
      <v-col style="text-align: center;">
        <span class="d-block  ct-text-14 titleGray--text">
          總固碳量單位為噸二氧化碳當量(ton CO2e)
        </span>
        <span class="d-block  ct-text-14 titleGray--text">
          採用1度電約排放0.494公斤二氧化碳為基準(參考臺電公告112年度電力排碳係數)
        </span>
        <span
          class="d-block"
          style="font-size:1.25rem; font-weight:600; color:#D92C3F"
        >
          (本功能係教學演示及估算用途，數據僅作為校園估算碳匯之參考，不具其他用途使用之效力)
        </span>
      </v-col>
    </v-row> -->
    <v-row class="d-flex justify-space-between align-center">
      <v-col>
        <MapTitle title="樹種比例分布" />
      </v-col>
    </v-row>
    <v-row
      v-if="sideStaticContent.treeCount > 0"
      class="d-flex justify-center align-center"
    >
      <v-col>
        <BarChart
          id="pieChart"
          :data-list="sideStaticContent.treeDistinctList"
          :type-list="$store.state.map.treeType"
          x-label="種"
          y-label="數量(棵)"
          label-key="percent"
          download-file-name="樹種比例"
        />
      </v-col>
    </v-row>
    <!-- 20250625 carbon hidden -->
    <!-- <v-row class="d-flex justify-space-between align-center">
      <v-col>
        <MapTitle title="碳匯比例分布" />
      </v-col>
    </v-row>
    <v-row
      v-if="sideStaticContent.treeCount > 0"
      class="d-flex justify-center align-center"
    >
      <v-col>
        <BarChart
          id="pieChart_Carbon"
          :data-list="carbonDistinct"
          :type-list="$store.state.map.treeType"
          x-label="種"
          y-label="kgCO2e"
          label-key="percent"
          download-file-name="碳匯比例"
        />
      </v-col>
    </v-row> -->
    <!-- 20250625 carbon hidden -->
    <!-- <v-row class="d-flex justify-space-between align-center">
      <v-col>
        <MapTitle title="測量結果分布" />
      </v-col>
    </v-row>
    <v-row
      v-if="sideStaticContent.treeCount > 0"
      class="d-flex justify-center align-center"
    >
      <v-col>
        <BarChart
          id="pieChart_H"
          sum-key="h"
          :data-list="sideStaticContent.treeDistinctList"
          :type-list="$store.state.map.treeType"
          x-label="種"
          y-label="平均樹高(m)"
          download-file-name="樹高分布"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="sideStaticContent.treeCount > 0"
      class="d-flex justify-center align-center"
    >
      <v-col>
        <BarChart
          id="pieChart_dbH"
          sum-key="dbh"
          :data-list="sideStaticContent.treeDistinctList"
          :type-list="$store.state.map.treeType"
          x-label="種"
          y-label="平均胸徑(cm)"
          download-file-name="胸徑分布"
        />
      </v-col>
    </v-row> -->
    <div
      v-if="sideStaticContent.treeCount > 0"
      style="overflow-x: auto;overflow-y: hidden;"
    >
      <v-row
        style="min-width: 900px;overflow: hidden;"
        class="d-flex justify-center align-center px-0 mx-0"
      >
        <v-col>
          <v-container>
            <v-row
              class="d-flex justify-center align-center mb-2 flex-nowrap"
              style="border-style: solid;
            border-width: 0 0 1px 0;
            border-color: #6B6B6B;"
            >
              <v-col cols="2" class="d-flex justify-center align-center">
                <th class="grey--text text--darken-2">樹種名稱</th>
              </v-col>
              <v-col class="d-flex justify-center align-center">
                <th class="grey--text text--darken-2">百科</th>
              </v-col>
              <v-col class="d-flex justify-center align-center">
                <th class="grey--text text--darken-2">數量(棵)</th>
              </v-col>
              <v-col class="d-flex justify-center align-center">
                <th class="grey--text text--darken-2">百分比</th>
              </v-col>
              <!-- 20250625 carbon hidden -->
              <!-- <v-col class="d-flex justify-center align-center">
                <th class="grey--text text--darken-2">碳匯估算(kgCO2e)</th>
              </v-col> -->
              <!-- 20250625 carbon hidden -->
              <!-- <v-col class="d-flex justify-center align-center">
                <th class="grey--text text--darken-2">百分比</th>
              </v-col> -->
              <!-- 20250625 carbon hidden -->
              <!-- <v-col class="d-flex justify-center align-center">
                <th class="grey--text text--darken-2">平均樹高(m)</th>
              </v-col>
              <v-col class="d-flex justify-center align-center">
                <th class="grey--text text--darken-2">平均胸徑(cm)</th>
              </v-col> -->
            </v-row>
            <!-- <v-row v-if="pagenition.page !== 1">
            <v-col>
              <div
                class="arrow up my-3 ma-auto d-flex justify-center align-center"
                style="width:150px"
                role="button"
                tabindex="0"
                title="上一頁"
                @click="prev()"
                @keypress="prev()"
              >
                <span class="sr-only">上一頁</span>
              </div>
            </v-col>
          </v-row> -->
            <v-row
              justify="center"
              align="center"
              class="my-2 contentBorder flex-nowrap"
              v-for="(item, i) in distinctSliceList"
              :key="i"
              :class="{
                b: i === distinctSliceList.length - 1 ? true : false
              }"
            >
              <v-col cols="2" class="d-flex justify-start align-center">
                <div class="mx-4 d-flex">
                  <v-avatar
                    class="ma-auto"
                    :color="CHART.setColor(item.name)"
                    size="16"
                  ></v-avatar
                  >&emsp;
                  <span style="display: inline-block;">
                    {{ SYS.setValueText(item.name, $store.state.map.treeType) }}
                  </span>
                </div>
              </v-col>
              <v-col class="d-flex justify-center align-center">
                <div
                  v-if="item.hasBook"
                  class="treeBtn my-0 mx-3"
                  role="button"
                  tabindex="0"
                  :title="
                    `前往${SYS.setValueText(
                      item.name,
                      $store.state.map.treeType
                    )}樹木小百科(另開新視窗)`
                  "
                  @click="goToBookDetails(item.name)"
                  @keypress="goToBookDetails(item.name)"
                >
                  <div class="ma-auto bg sm">
                    <div class="ma-auto book sm"></div>
                  </div>
                </div>
              </v-col>
              <v-col class="d-flex justify-center align-center">
                {{ TOOL.thousandComma(item.count) }}
              </v-col>
              <v-col class="d-flex justify-center align-center">
                {{ item.percent }}%
              </v-col>
              <!-- 20250625 carbon hidden -->
              <!-- <v-col class="d-flex justify-center align-center">
                {{ TOOL.thousandComma(parseInt(item.tonCO2e * 1000)) }}
              </v-col> -->
              <!-- 20250625 carbon hidden -->
              <!-- <v-col class="d-flex justify-center align-center">
                {{ (TOOL.toNumber(item.tonCO2e / tonCO2e) * 100).toFixed(1) }}%
              </v-col> -->
              <!-- 20250625 carbon hidden -->
              <!-- <v-col class="d-flex justify-center align-center">
                {{ TOOL.toNumber(item.h).toFixed(1) }}
              </v-col>
              <v-col class="d-flex justify-center align-center">
                {{ TOOL.toNumber(item.dbh).toFixed(1) }}
              </v-col> -->
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </div>
    <div v-if="sideStaticContent.treeCount > 0">
      <v-row
        v-if="
          pagenition.page !==
            Math.ceil(
              sideStaticContent.treeDistinctList.length / pagenition.count
            )
        "
      >
        <v-col>
          <div
            class="arrow bottom my-3 ma-auto d-flex justify-center align-center"
            style="width:150px"
            role="button"
            tabindex="0"
            title="下一頁"
            @click="next()"
            @keypress="next()"
          >
            <span class="sr-only">下一頁</span>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-row v-else class="d-flex justify-center align-center">
      <v-col>
        <div style="text-align:center">
          暫無調查資料
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    MapTitle: () => import("@/components/map/mapTitle.vue"),
    StaticChip: () => import("@/components/map/staticChip.vue"),
    BarChart: () => import("@/components/map/barChart.vue")
  },
  props: {
    sideStaticContent: {
      type: Object,
      default() {
        return {
          hasInfoCard: false,
          treeList: [],
          treeDistinctList: []
        };
      }
    }
  },
  data() {
    return {
      treeSet: [
        {
          name: "榕樹",
          count: 56,
          percent: 49.3
        },
        {
          name: "榕樹",
          count: 56,
          percent: 49.3
        },
        {
          name: "榕樹",
          count: 56,
          percent: 49.3
        },
        {
          name: "榕樹",
          count: 56,
          percent: 49.3
        }
      ],
      pagenition: {
        count: 10,
        page: 1
      },
      distinctSliceList: []
    };
  },
  computed: {
    carbonDistinct() {
      return this.sideStaticContent.treeDistinctList
        .map(p => {
          return {
            name: p.name,
            count: parseInt(p.tonCO2e * 1000),
            percent: (
              this.TOOL.toNumber(p.tonCO2e / this.tonCO2e) * 100
            ).toFixed(1)
          };
        })
        .sort((a, b) => {
          if (a.count - b.count < 0) {
            return 1;
          } else {
            return -1;
          }
        });
    },
    tonCO2e() {
      let sum = 0;
      const arr = this.sideStaticContent.treeDistinctList;
      if (Array.isArray(arr)) {
        for (let i = 0; i < arr.length; i++) {
          if (!Number.isNaN(arr[i].tonCO2e)) {
            sum += arr[i].tonCO2e;
          }
        }
      }
      return sum;
    },
    kWh() {
      return Math.round((this.tonCO2e * 1000) / 0.494);
    }
  },
  mounted() {
    this.distinctSliceList = this.sideStaticContent.treeDistinctList.slice(
      0,
      this.pagenition.count
    );
  },
  methods: {
    prev() {
      let page = this.pagenition.page;
      page--;
      let data = this.sideStaticContent.treeDistinctList;
      if (page < 1) page = Math.ceil(data.length / this.pagenition.count);
      let first = this.pagenition.count * (page - 1);
      this.distinctSliceList = data.slice(first, first + this.pagenition.count);
      this.pagenition.page = page;
    },
    next() {
      let page = this.pagenition.page;
      page++;
      let data = this.sideStaticContent.treeDistinctList;
      if (page > Math.ceil(data.length / this.pagenition.count)) page = 1;
      // 20240712 Ben說改成一直往下加
      // let first = this.pagenition.count * (page - 1);
      // this.distinctSliceList = data.slice(first, first + this.pagenition.count);
      let first = 0;
      this.distinctSliceList = data.slice(
        first,
        this.pagenition.count * (page - 1) + this.pagenition.count
      );
      this.pagenition.page = page;
    },
    goToBookDetails(id) {
      let routeData = this.$router.resolve({
        name: "Book-Detail",
        query: {
          name: id
        }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.contentBorder {
  border-style: none none dashed none;
  border-width: 1px;
  border-color: #a3a3a3;
  &.b {
    border-style: none;
  }
}
.pieChart {
  position: relative !important;
}

.transform90 {
  transform: rotate(90deg);
}

.btnTreeQR {
  height: 53px;
  width: 173px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-image: url("~@/assets/images/map/sideStatic/map_tree_qr_btn_hover.png");
  &:hover {
    background-image: url("~@/assets/images/map/sideStatic/map_tree_qr_btn.png");
  }
}
</style>
